export * from "./ContentMedium";
